import { render, staticRenderFns } from "./Loans.vue?vue&type=template&id=a1368b7c&scoped=true"
import script from "./Loans.vue?vue&type=script&lang=js"
export * from "./Loans.vue?vue&type=script&lang=js"
import style0 from "./Loans.vue?vue&type=style&index=0&id=a1368b7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1368b7c",
  null
  
)

export default component.exports